<template>
  <el-dialog title="编辑网关"
             :visible.sync="showModal"
             @close="handleCancel"
             width="40%">
    <el-col :span="24">
      <el-form :model="modalInfo"
               :rules="modalRules"
               ref="modalForm"
               label-width="100px"
               class="modal-form">
        <el-form-item label="网关名称："
                      prop="name">
          <el-input v-model.trim="modalInfo.name"
                    placeholder="请输入网关名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="在线状态："
                      prop="online">
          <el-radio-group disabled
                          v-model="modalInfo.online">
            <el-radio label="1">在线</el-radio>
            <el-radio label="0">离线</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="激活状态："
                      prop="activated">
          <el-radio-group disabled
                          v-model="modalInfo.activated">
            <el-radio label="1">已激活</el-radio>
            <el-radio label="0">未激活</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="所属区域："
                      prop="area_id">
          <el-select v-model="modalInfo.area_id"
                     placeholder="请选择所属区域">
            <el-option v-for="item in areaList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="设备数量："
                      prop="lock_count">
          <el-input disabled
                    v-model.trim="modalInfo.lock_count"
                    placeholder="请输入设备数量"></el-input>
        </el-form-item>
        <el-form-item label="sn："
                      prop="sn">
          <el-input disabled
                    v-model.trim="modalInfo.sn"
                    placeholder="请输入网关编号"></el-input>
        </el-form-item>
        <el-form-item label="ClientId："
                      prop="clientid">
          <el-input v-model.trim="modalInfo.clientid"
                    placeholder="请输入ClientId"></el-input>
        </el-form-item> -->
        <el-form-item label="备注："
                      prop="remarks">
          <el-input type="textarea"
                    v-model.trim="modalInfo.remarks"
                    placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
    </el-col>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button v-has="'/gate/edit'"
                 type="primary"
                 @click="handleConfirm('modalForm')">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      showModal: this.isShow,
      modalInfo: {
        name: '',
        online: '',
        activated: '',
        area_id: '',
        lock_count: '',
        sn: '',
        clientid: '',
        regtime: '',
        remarks: ''
      },
      modalRules: {
        name: [{ required: true, message: '请输入网关名称' }],
        online: [{ required: true, message: '请选择在线状态' }],
        activated: [{ required: true, message: '请选择激活状态' }],
        area_id: [{ required: true, message: '请选择所属区域' }],
        lock_count: [{ required: true, message: '请输入设备数量' }],
        sn: [{ required: true, message: '请输入网关编号' }],
        clientid: [{ required: true, message: '请输入MQTT ID' }]
      },
      areaList: [],
      tmpArr: []
    }
  },
  created() {
    this.getList()
    this.getInfo()
  },
  methods: {
    // 获取编辑信息
    getInfo() {
      fetch.getGateInfo({ id: this.data.id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.modalInfo = data.info
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取数据
    getList() {
      fetch.getAreaTree({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.areaList = this.titleFormat(data.treeData, '• ')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          fetch.editGate({ ...this.modalInfo }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.$message.success('操作成功')
                this.handleCancel('refresh')
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        } else {
          return false
        }
      })
    },
    handleCancel(type) {
      this.$emit('handleClose', type)
    },
    //  格式化名称
    titleFormat(data, prefix) {
      if (data.length === 0) {
        return []
      }
      data.forEach((item) => {
        let tmp = item
        tmp.name = prefix + item.name
        this.tmpArr.push(tmp)
        if (item.children && item.children.length > 0) {
          this.titleFormat(item.children, '• ' + prefix)
        }
      })
      return this.tmpArr
    }
  }
}
</script>

<style></style>
